export const hasFeaturedAuthor = (article, type = null) => {
  if (
    (!type || type === 'article')
    && article && article.authors && article.authors[0]
    && article.authors[0].featuredAuthor.isFeaturedAuthor
  ) {
    return true;
  }

  return false;
};

export const getFeaturedAuthor = (article, type = null) => {
  let result = null;

  if (hasFeaturedAuthor(article, type)) {
    result = article.authors[0].person.name;
  }

  return result;
};
